import React from "react"
import PropTypes from "prop-types"
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap"

// Shown to someone who already has a garden set up. Different framing from the
// new-user intro: this is an offer, not a walkthrough they are being held in,
// and the reassurance about existing work is the part that matters.
const SectorMapInviteModal = ({ isOpen, onStart, onDecline }) => (
  <Modal isOpen={isOpen} size="lg" centered toggle={onDecline}>
    <ModalHeader tag="h4" toggle={onDecline}>
      Try the new Sector Map
    </ModalHeader>
    <ModalBody>
      <p>
        In permaculture, a key aspect of designing a successful garden is
        observing how you interact with it and the external forces that shape and
        move across it. A Sector Map helps you organize this information so you
        design a garden more in tune with nature and your lifestyle.
      </p>
      <p>
        If you haven&apos;t yet created a design, we recommend this as a new way
        to bootstrap your garden design process. If you already have a design
        physically laid out in the Designer, you can still use this feature to add
        additional information about zones, buildings, wind, and sun.
      </p>
      <p>
        <b>It won&apos;t change or remove anything you&apos;ve already drawn.</b>{" "}
        Everything it finds is shown to you first, and you decide what to keep.
      </p>
      <p style={{ fontSize: 13, opacity: 0.75 }}>
        You can leave at any point and come back to your design as it was.
      </p>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <Button color="secondary" onClick={onDecline}>
          Not now
        </Button>
        <Button color="info" onClick={onStart}>
          Start Sector Map
        </Button>
      </div>
    </ModalBody>
  </Modal>
)

SectorMapInviteModal.propTypes = {
  isOpen: PropTypes.bool,
  onStart: PropTypes.func,
  onDecline: PropTypes.func,
}

export default SectorMapInviteModal
